import script from "./ProjectRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectRow.vue?vue&type=script&setup=true&lang=js"

import "./ProjectRow.vue?vue&type=style&index=0&id=0753f06f&scoped=true&lang=scss"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0753f06f"]])

export default __exports__